import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { gameDataActions } from '../Store/Actions/gameDataActions';
import { GAME_STATE, MODAL_FLAG } from '../Helpers/constants';
import { Label } from './Common/OkoylUI';

const CityDisplayBox = ({ cityData }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [currentShop, setCurrentShop] = useState(null);

    const handleShopClick = (shop) => {
        dispatch(gameDataActions.modalData.set(true, MODAL_FLAG.SHOP, shop));
        dispatch(gameDataActions.setGameState(GAME_STATE.MODAL));
    };

    const displayShops = () => {
        if (!cityData?.shops) return null;
        return Object.values(cityData.shops).map((shop, index) => {
            if (!shop) return null;
            return (
                <div key={index} style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                    <button
                        type="button"
                        onClick={() => handleShopClick(shop)}
                        onMouseEnter={() => setCurrentShop(shop)}
                        style={{
                            width: 44, height: 44,
                            background: 'var(--ash-900)',
                            border: '1px solid rgba(200,144,42,0.32)',
                            borderRadius: 'var(--r-md)',
                            color: 'var(--okoyl-200)',
                            fontSize: 22,
                            cursor: 'pointer',
                            transition: 'all var(--dur-2) var(--ease-out)',
                        }}
                    >
                        {shop.icon}
                    </button>
                    <span style={{ fontFamily: 'var(--font-body)', fontSize: 14, color: 'var(--ash-200)' }}>
                        {shop.name}
                    </span>
                </div>
            );
        });
    };

    if (cityData) {
        return (
            <div className="okcard okcard-bare" style={{ marginTop: 16 }}>
                <div style={{ padding: '12px 16px 6px' }}>
                    <Label color="gold">{t('cityDisplayBox.title')}</Label>
                </div>
                <div style={{ padding: '0 16px 16px' }}>
                    <p className="oklore oklore-sm" style={{ marginBottom: 12 }}>
                        {t('cityDisplayBox.inCity')}{' '}
                        <span style={{ fontFamily: 'var(--font-display)', letterSpacing: '0.12em', textTransform: 'uppercase', color: 'var(--okoyl-200)' }}>
                            {cityData.name}
                        </span>
                    </p>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12, marginBottom: 12 }}>
                        {displayShops()}
                    </div>
                    {currentShop && (
                        <div style={{ marginTop: 8, padding: 12, background: 'var(--ash-900)', border: '1px solid rgba(200,144,42,0.18)', borderRadius: 'var(--r-md)', display: 'flex', alignItems: 'center', gap: 12 }}>
                            <span style={{ fontSize: 32 }}>{currentShop.icon}</span>
                            <div>
                                <div style={{ fontFamily: 'var(--font-display)', fontSize: 13, letterSpacing: '0.12em', textTransform: 'uppercase', color: 'var(--okoyl-200)' }}>
                                    {currentShop.name}
                                </div>
                                <p className="oklore oklore-sm" style={{ marginTop: 2 }}>
                                    {currentShop.description}
                                </p>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    }

    return (
        <div className="okcard" style={{ marginTop: 16, textAlign: 'center' }}>
            <p className="oklore oklore-sm">{t('cityDisplayBox.adventuring')}</p>
        </div>
    );
};

export default CityDisplayBox;
